import { DataBean } from "../DataBean";

export class NoveltyAccount extends DataBean {

  public async getNoveltyAccountCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "java.util.List_getNoveltyAccountCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getNoveltyAccount(idnoveltyaccount: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.NoveltyAccount_getNoveltyAccount_Number",
      [idnoveltyaccount]
    );
  }

  public async deleteNoveltyAccount(idnoveltyaccount: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "boolean_deleteNoveltyAccount_Number",
      [idnoveltyaccount]
    );
  }

  public async updateNoveltyAccount(bean: any): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.NoveltyAccount_updateNoveltyAccount_com.orange.people.talent.bean.NoveltyAccount",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.people.talent.bean.NoveltyAccount",
        },
      ]
    );
  }
}
